import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { CHILDRENS_LIST_TAB } from '../../Constants'


const Tabcontainer = styled.div`
  width: 100%;
  height: 40px;
  background-color: red;
  display: none;
  border-bottom: solid 10px;
  border-bottom-color: #e2e9ec;
  @media (max-width: 763px) {
    visibility: visible;
    display: flex;
    flex-direction: row;
  }
`
const Tab = styled.div`
  width: 33%;
  height: 40px;
  background-color: #f92235;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  box-shadow: ${props => props.active ? 'inset 0 -3px 0 white' : ''};
`


class Tabs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tab1: true,
      tab2: false,
      tab3: false,
      inUse: false,
    }
    this.tab1 = this.tab1.bind(this)
    this.tab2 = this.tab2.bind(this)
    this.tab3 = this.tab3.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tab === 'all') {
      this.setState({ inUse: false })
    }
  }

  tab1() {
    this.setState({ tab1: true, tab2: false, tab3: false })
    this.props.filter('all', true)
  }

  tab2() {
    this.setState({ tab1: false, tab2: true, tab3: false, inUse: true })
    this.props.filter('active', true)
  }

  tab3() {
    this.setState({ tab1: false, tab2: false, tab3: true, inUse: true })
    this.props.filter('inactive', true)
  }


  render() {
    return (
      <Tabcontainer>
        <Tab active={this.props.tab === 'all' && !this.state.inUse ? true : this.state.tab1 } onClick={this.tab1} >
          <span>{CHILDRENS_LIST_TAB.todos}</span>
        </Tab>
        <Tab active={this.props.tab === 'all' && !this.state.inUse ? false : this.state.tab2} onClick={this.tab2} >
          <span>{CHILDRENS_LIST_TAB.presentes}</span>
        </Tab>
        <Tab active={ this.props.tab === 'all' && !this.state.inUse ? false : this.state.tab3} onClick={this.tab3} >
          <span>{CHILDRENS_LIST_TAB.ausentes}</span>
        </Tab>
      </Tabcontainer>
    )
  }
}

Tabs.propTypes = {
  filter: PropTypes.func,
}
Tabs.defaultProps = {
  filter: () => {},
}

export default Tabs



// WEBPACK FOOTER //
// ./src/Components/Tabs/index.jsx